import axios from 'axios'
import Auth from './auth'
import TStorage from 'src/scripts/Storage'

const API_SERVER_ESOCIAL_URL = process.env.REACT_APP_SERVER_ESOCIAL_URL

// const SESSION_TOKEN = process.env.REACT_APP_LOCAL_TOKEN_NAME
// const SESSION_REFRESHTOKEN = process.env.REACT_APP_LOCAL_REFRESH_TOKEN_NAME

// const defaultSign = {
//   signed: false,
//   data: {
//     user_key: 0,
//     user_id: '',
//     user_email: '',
//     user_name: '',
//     user_role: '',
//     create_date: '',
//     token_expiration_date: '',
//     token: '',
//     refresh_token_expiration_date: '',
//     refresh_token: '',
//   },
//   error: {},
// }

// function getLocalAccessToken() {
//   const accessToken = localStorage.getItem(SESSION_TOKEN)
//   return accessToken
// }

// function getLocalRefreshToken() {
//   const refreshToken = localStorage.getItem(SESSION_REFRESHTOKEN)
//   return refreshToken
// }

const ESocial = axios.create({
  headers: {
    'Access-Control-Allow-Origin': '*',
  },
  baseURL: API_SERVER_ESOCIAL_URL,
})

ESocial.interceptors.request.use(
  config => {
    const accessToken = TStorage.AccessToken()
    if (accessToken) {
      config.headers['Authorization'] = `bearer ${accessToken}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  },
)

ESocial.interceptors.response.use(
  response => {
    return response
  },
  async function (error) {
    const originalConfig = error.config

    if (error.response) {
      // Access Token was expired
      if (error.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true

        try {
          const accessToken = TStorage.AccessToken()
          const refreshToken = TStorage.RefreshToken()
          await Auth.refreshToken(accessToken, refreshToken)

          ESocial.defaults.headers.common['Authorization'] = `bearer ${accessToken}`

          return ESocial(originalConfig)
        } catch (_error) {
          if (_error.response && _error.response.data) {
            return Promise.reject(_error.response.data)
          }

          return Promise.reject(_error)
        }
      }

      if (error.response.status === 403 && error.response.data) {
        return Promise.reject(error.response.data)
      }
    }

    return Promise.reject(error)
  },
)

export default ESocial
